import React from 'react';
import HomePage from './home';
import HomePageExperiment from './home-experiment';
import { ExperimentWrapper } from '../../components/generic/experiment-wrapper';

const EXPERIMENT_NAME = 'sac-home-redesign';

export default function render(entry, pageTree, featureFlags) {
    return (
        <>
            {/* Treatment variant - renders when experiment IS enabled */}
            <ExperimentWrapper
                experimentName={EXPERIMENT_NAME}
                experimentParameter="isEnabled"
                defaultValues={{ isEnabled: false }}
                customAttributes={{
                    pageId: entry?.id,
                    pageType: 'home'
                }}
                customErrorAttributes={{
                    componentName: 'HomePageExperiment'
                }}
                source="home-page"
            >
                <HomePageExperiment entry={entry} featureFlags={featureFlags} />
            </ExperimentWrapper>

            {/* Control variant - renders when experiment is NOT enabled */}
            <ExperimentWrapper
                experimentName={EXPERIMENT_NAME}
                experimentParameter="isEnabled"
                defaultValues={{ isEnabled: false }}
                customAttributes={{
                    pageId: entry?.id,
                    pageType: 'home'
                }}
                customErrorAttributes={{
                    componentName: 'HomePageControl'
                }}
                source="home-page"
                invertLogic={true}
            >
                <HomePage entry={entry} featureFlags={featureFlags} />
            </ExperimentWrapper>
        </>
    );
}
